<script setup>
import { computed } from "vue";

const props = defineProps({
  items: {
    type: Array,
    default: () => [],
  },
});

const total = computed(() =>
  props.items.reduce((sum, item) => sum + item.value, 0),
);
const normalizedItems = computed(() =>
  props.items.map((item) => ({
    ...item,
    percent: total.value ? Math.round((item.value / total.value) * 100) : 0,
  })),
);

const formatCurrency = (value) => {
  return new Intl.NumberFormat("th-TH", {
    style: "currency",
    currency: "THB",
    minimumFractionDigits: 0,
  }).format(value || 0);
};
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h5 class="fw-bold mb-1">สัดส่วนการรับชำระตามช่องทาง</h5>
          <div class="text-muted small">
            สรุปยอดรับชำระโดยแยกตามประเภทช่องทางการชำระเงิน
          </div>
        </div>
        <i class="bi bi-pie-chart text-success fs-4"></i>
      </div>

      <div class="vstack gap-3">
        <div v-for="item in normalizedItems" :key="item.label">
          <div class="d-flex justify-content-between small mb-1">
            <span class="fw-semibold">{{ item.label }}</span>
            <span class="text-muted"
              >{{ formatCurrency(item.value) }} ({{ item.percent }}%)</span
            >
          </div>
          <div class="progress rounded-pill" style="height: 10px">
            <div
              class="progress-bar"
              :class="`bg-${item.color}`"
              :style="{ width: `${item.percent}%` }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
